import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { currentUser, userData } = useAuth();
  let location = useLocation();

  if (!currentUser) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to. This allows us to send them back after they log in.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is logged in but hasn't finished onboarding (no familyId)
  if (currentUser && !userData?.familyId) {
    // Allow access only to the onboarding page
    if (location.pathname !== '/onboarding') {
      return <Navigate to="/onboarding" replace />;
    }
  }

  // If user is logged in AND has a familyId, but tries to go to onboarding
  if (currentUser && userData?.familyId && location.pathname === '/onboarding') {
    return <Navigate to="/" replace />;
  }


  return children;
};

export default PrivateRoute;